import * as React from "react";
import { Page } from "ui/components";
import styles from "./Loading.module.scss";

interface Props {
    text: string;
}

const Loading: React.FC<Props> = ({ text }) => (
    <Page theme="dark" padding={false} centered>
        <div className={styles.container}>
            <span className={styles.dot__container}>
                <span className={styles.dot} />
                <span className={styles.dot} />
                <span className={styles.dot} />
                <span className={styles.dot} />
                <span className={styles.dot} />
            </span>
            <h3>{text}</h3>
        </div>
    </Page>
);

export default Loading;
